import React from "react";
import dynamic from "next/dynamic";

// components
import Modal, { ModalProps } from "@/shared/Modal";

// components
const SubscriptionForm = dynamic(() => import("@/components/Form/SubscriptionForm"), { ssr: false, loading: () => <span>Loading...</span> });

// assets
import styles from "@/assets/styles/components/Modals/subscription-modal.module.scss";

const SubscriptionModal = ({ open, onCancel, ...props }: ModalProps) => {

  return (
    <Modal
      centered
      open={open}
      onCancel={onCancel}
      footer={null}
      className={styles["locl-subscription-modal"]}
      destroyOnClose
      {...props}
    >
      {open && (
        <SubscriptionForm onClose={() => onCancel && onCancel()} />
      )}
    </Modal>
  )
};

export default SubscriptionModal;
